const lumerisAddressAutocomplete = require('../components/lumeris-address-autocomplete.js');

(($) => {
    let $gravityFormsWrappers;

    window.addEventListener('load', init);

    function init() {
        $gravityFormsWrappers = $('.gform_wrapper');

        if ($gravityFormsWrappers.length == 0) {
            return null;
        }
        
        $gravityFormsWrappers.each(addAbbrevStatesPattern);
        $gravityFormsWrappers.each(addEmptyOr10DigitPhoneNumbersPattern);
        $gravityFormsWrappers.each(textUpperCase);
        $gravityFormsWrappers.each(validateZipCode);
        $gravityFormsWrappers.each(addressAutocomplete);
    }

    function addAbbrevStatesPattern(elIndex, el) {
        if (typeof el == 'undefined') {
            return null;
        }

        const pattern = 'AL|AK|AZ|AR|CA|CO|CT|DE|FL|GA|HI|ID|IL|IN|IA|KS|KY|LA|ME|MD|MA|MI|MN|MS|MO|MT|NE|NV|NH|NJ|NM|NY|NC|ND|OH|OK|OR|PA|RI|SC|SD|TN|TX|UT|VT|VA|WA|WV|WI|WY';
        const validationMessage = 'Please enter a valid two-character state abbreviation.';

        const $gravityFormWrapper = $(el);
        const $inputs = $gravityFormWrapper.find('.gfield.abbrev-states-pattern input');

        if ($inputs.length == 0) {
            return false;
        }

        $inputs.attr('pattern', pattern);

        $inputs.on('keyup change', (event) => {
            $(event.target).val($(event.target).val().toUpperCase());
        });
        
        $inputs.on('invalid', (event) => {
            event.target.setCustomValidity(validationMessage);
        });
    }

    function addEmptyOr10DigitPhoneNumbersPattern(elIndex, el) {
        if (typeof el == 'undefined') {
            return false;
        }
        const pattern = '|\\(?[2-9][0-9]{2}\\)? ?-?\\.?[0-9]{3} ?-?\\.?[0-9]{4}';
        const validationMessage = 'Please enter your ten-digit phone number with area code (no dashes or other special characters).';

        const $gravityFormWrapper = $(el);
        const $inputs = $gravityFormWrapper.find('.gfield.empty-or-10-digit-phone-number-pattern input');

        if ($inputs.length == 0) {
            return false;
        }

        $inputs.attr('pattern', pattern);
        
        $inputs.on('keyup change input paste focus', (event) => {
            event.target.setCustomValidity('');
        });

        $inputs.on('invalid', (event) => {
            event.target.setCustomValidity(validationMessage);s
        });
    }

    function textUpperCase(elIndex, el) {
        if (typeof el == 'undefined') {
            return null;
        }

        const $gravityFormWrapper = $(el);
        const $inputs = $gravityFormWrapper.find('.gfield.text-uppercase input');

        if ($inputs.length == 0) {
            return null;
        }

        $inputs.on('keyup change input paste focus', (event) => {
            $(event.target).val($(event.target).val().toUpperCase());
        });
    }

    function validateZipCode(elIndex, el) {
        if (typeof el == 'undefined') {
            return null;
        }

        const $gravityFormWrapper = $(el);
        const $inputs = $gravityFormWrapper.find('.gfield.validate--five-digit-zipcode input');

        if ($inputs.length == 0) {
            return null;
        }
        
        $inputs.on('keyup change input paste focus', (event) => {
            if (!event) {
                return false;
            }
            let $target = $(event.target);
            let validatedVal = $target.val().replace(/\D/g, '').slice(0, 5);
            $target.val(validatedVal);
        });
    }

    function addressAutocomplete(elIndex, el) {
        if (typeof el == 'undefined') {
            return null;
        }

        const $gravityFormWrapper = $(el);
        const $form = $gravityFormWrapper.find('form.has-address-autocomplete');

        if ($form.length == 0) {
            return null;
        }

        const $streetAddress = $form.find('.gfield.street-address input');
        const $streetAddress2 = $form.find('.gfield.street-address input');
        const $city = $form.find('.gfield.city input');
        const $state = $form.find('.gfield.state select, .gfield.state input');
        const $zipCode = $form.find('.gfield.zip-code input');

        const $dropdown = $('<div class="address-autocomplete-dropdown"></div>');

        const addressAutocomplete = new lumerisAddressAutocomplete({
            $form: $form,
            $streetAddressField: $streetAddress,
            $streetAddress2Field: $streetAddress2,
            $cityField: $city,
            $stateField: $state,
            $zipCodeField: $zipCode
        });
    }

})(jQuery);